import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { HttpHeadersService } from 'src/app/core/shared-service/http-headers.service';
import { environment } from 'src/environments/environment';
import { ApiDocsService } from './api-docs.service';

@Component({
  selector: 'app-api-docs',
  templateUrl: './api-docs.component.html',
  styleUrls: ['./api-docs.component.css']
})
export class ApiDocsComponent implements OnInit {
  token: string | null;
  iframeData: string;
  constructor(
    private apiDocServ: ApiDocsService
  ) { }

  ngOnInit(): void {
    this.token = localStorage.getItem("gcpToken");
    this.getData();
  }

  applyToken(data: string) {
    data = data.trim();
    if(!data) return;
    this.token = data;
    localStorage.setItem("gcpToken", data);
    this.getData();
  }

  clearToken() {
    this.token = null;
    localStorage.removeItem("gcpToken");
  }

  private async getData() {
    if(!this.token) return;
    try {
      const data = await this.apiDocServ.get('https://qa-webapi.halo.fitness/servicenotices-agent/v1/halo-api-docs/');
      this.iframeData = "javascript:'"+data+"'";
    } catch (error) {
      console.error(error);
    }
  }
}
